import React, { ChangeEvent, JSX, useCallback, useEffect, useState } from 'react';

import { Box, Button, Checkbox, FormControlLabel, Stack, TextField } from '@mui/material';

import { RateCodeFormValues } from '../types';

const INITIAL_FORM_STATE: RateCodeFormValues = {
  id: '',
  code: '',
  vendorId: '',
  isFlash: false,
  isEnabled: false,
};

type Props = {
  rateCodeFormValues?: RateCodeFormValues;
  onSubmit: (formValues: RateCodeFormValues) => void;
};

function RateCodeForm({ rateCodeFormValues, onSubmit }: Props): JSX.Element {
  const [formValues, setFormValues] = useState<RateCodeFormValues>(INITIAL_FORM_STATE);

  const handleCheck = useCallback(
    (event: ChangeEvent<HTMLInputElement>, checked: boolean) => {
      if (event.target.name) {
        setFormValues({ ...formValues, [event.target.name]: checked });
      }
    },
    [formValues],
  );

  const handleSubmit = useCallback(() => {
    onSubmit(formValues);
  }, [formValues, onSubmit]);

  useEffect(() => {
    if (rateCodeFormValues) {
      setFormValues(rateCodeFormValues);
    }
  }, [rateCodeFormValues]);

  return (
    <Box>
      <Stack mt={2} spacing={2} direction="row">
        <TextField
          disabled
          fullWidth
          name="rateCode"
          label="Rate Code"
          value={formValues.code}
          InputProps={{ readOnly: true }}
        />

        <TextField
          disabled
          fullWidth
          name="vendorId"
          label="Vendor ID"
          value={formValues.vendorId}
          InputProps={{ readOnly: true }}
        />
      </Stack>

      <Box mt={2}>
        <FormControlLabel
          label="Is Flash?"
          control={<Checkbox required name="isFlash" onChange={handleCheck} checked={formValues.isFlash} />}
        />
      </Box>

      <Box mt={2}>
        <FormControlLabel
          label="Is Enabled?"
          control={<Checkbox required name="isEnabled" onChange={handleCheck} checked={formValues.isEnabled} />}
        />
      </Box>

      <Box mt={2}>
        <Button variant="contained" onClick={handleSubmit}>
          Save Changes
        </Button>
      </Box>
    </Box>
  );
}

export default RateCodeForm;
